import { create } from "zustand";
import flipSound from '@/assets/sounds/flip.mp3'

interface ModalStore {
    mode: ModalMode;
    isOpen: boolean;
    onOpen: (mode: ModalMode) => void;
    onClose: () => void;
}

const useModalStore = create<ModalStore>((set) => ({
    mode: null,
    isOpen: false,
    onOpen: (mode: ModalMode) => {
        set({ mode, isOpen: true })
        new Audio(flipSound).play()
    },
    onClose: () => {
        set({ mode: null, isOpen: false })
        new Audio(flipSound).play()
    },
}))

export default useModalStore;
